<template>
    <div id="home-pc">
        <!-- header -->
        <div class="header-wrap" id="header-wrap-id">
            <a id="s-summary"></a>
            <transition name="fade">
                <div class="nav" v-show="showNav">
                    <ul>
                        <li><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#s-summary">首页</a></li>
                        <li v-if="false"><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#past-guest">往期嘉宾</a></li>
                        <li><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#s-guest">邀请嘉宾</a></li>
                        <li><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#s-agenda">大会议程</a></li>
                        <li><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#s-award">奖项评选</a></li>
                        <li><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#s-tickets">参会购票</a></li>
                        <li v-if="false"><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  :href="ticketUrl" target="_blank">参会购票</a></li>
                        <li><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#s-partners">合作机构</a></li>
                        <li><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#s-contact-us">联系我们</a></li>
                    </ul>
                </div>
            </transition>
        </div>

        <div class="intro-content">
            <div class="intro-normal">
                小饭桌青年创业者大会此前已成功举办四届，是创投圈TOP级别的年度盛宴。第5届小饭桌青年创业者大会以“乘风破浪，逆风而行”为主题，聚焦创投圈，关注新风向，深度剖析全年新经济发展态势，预见下一年机会所在，是一场属于创业者和投资人的盛会。
                <br><br>
                在不确定的市场寻找确定性的机会
                <br><br>
                在没有英雄主义的时代选出推动经济变革的英雄
                <br><br>
                好风凭借力，送我上青云，小饭桌与你一起预见2021
            </div>
            <div class="intro-bold" v-if="false"> TRUST 相信，相信的力量！</div>
        </div>

        <!-- 已邀嘉宾 -->
        <div id="guest-bg-area">
            <p id="s-guest"></p>
            <div class="section guest" id="guest-wrap-id">
            <div class="s-title">
                <div class="zh-wrap">
                    <span class="zh">已邀嘉宾</span>
                    <span class="tip">按出场顺序排</span>
                </div>
            </div>
            <ul class="guest-list">
                <li v-for="(guest, index) in guestList">
                    <div class="photo">
                        <div class="left-top"></div>
                        <img :src="guest.photo" alt="嘉宾">
                        <div class="right-bottom">
                            <div class="g-name"> {{guest.name}} </div>
                            <div class="g-title"> {{guest.position}} </div>
                        </div>
                    </div>
                </li>
            </ul>
            </div>
        </div>
        <!-- 往期嘉宾 -->
        <div v-if="false" class="section past-guest" id="past-guest">
            <p id="s-past-guest"></p>
            <div class="s-title"> <div class="zh"> 往期嘉宾</div> </div>
            <ul>
                <li>
                    <a href="https://www.bufanbiz.com/post/5069.html" target="_blank">
                        <img src="../assets/e-wap/jim.png">
                        <img class="play-btn" src="../assets/e-wap/play.png">
                    </a>
                </li>
                <li>
                    <a href="https://www.bufanbiz.com/post/5072.html" target="_blank">
                        <img src="../assets/e-wap/zhangying.png">
                        <img class="play-btn" src="../assets/e-wap/play.png">
                    </a>
                </li>
                <li>
                    <a href="https://www.bufanbiz.com/post/5078.html" target="_blank">
                        <img src="../assets/e-wap/tuobuhua.png">
                        <img class="play-btn" src="../assets/e-wap/play.png">
                    </a>
                </li>
                <li>
                    <a href="https://www.bufanbiz.com/post/1897.html" target="_blank">
                        <img src="../assets/e-wap/qasar.png">
                        <img class="play-btn" src="../assets/e-wap/play.png">
                    </a>
                </li>
                <li>
                    <a href="https://www.bufanbiz.com/post/1916.html" target="_blank">
                        <img src="../assets/e-wap/xiaowenjie.png">
                        <img class="play-btn" src="../assets/e-wap/play.png">
                    </a>
                </li>
            </ul>
        </div>
        <!-- agdnda day1 -->
        <div id="agenda-bg-area" v-if="false">
            <div class="section agenda-2">
                <div class="agenda-top"> <p id="s-agenda"></p> </div>
                <div class="s-title">
                    <div class="zh-wrap">
                        <span class="zh">大会议程</span>
                    </div>
                </div>
                <img src="https://static-miniapp.xfz.cn/2019-agenda-2.png">
            </div>
        </div>

        <div id="agenda-bg-area" >
            <div class="section agenda">

                <div class="agenda-top"> <p id="s-agenda"></p> </div>
                <div class="s-title">
                    <div class="zh-wrap">
                        <span class="zh">大会议程</span>
                    </div>
                </div>

                <div class="agenda-title-bottom"></div>
                <template v-for="(type,index) in agendaData.type[0]">
                    <div :class="'agenda-group-'+index">
                        <div :class="'agenda-group-center-'+index" class="agenda-group-center">
                            <div class="conf-host" :class="'agenda-theme-' + index" >
                                <div class="which-conf" v-if="false">
                                    <span v-html="type"></span>
                                    <a href="http://j.map.baidu.com/h4z9P" class="see-map" target="_blank">查看地图</a>
                                </div>
                            </div>
                            <div class="agenda-list">
                                <template v-for="(agenda,index) in agendaData.meeting[type]">
                                    <agenda-item :data="agenda" :type="type" :index="index"></agenda-item>
                                </template>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="time-address">时间：2020年11月26日 &nbsp; &nbsp; &nbsp; &nbsp; 地点：中国北京·千禧大酒店二层大宴会厅</div>
            </div>
        </div>

        <!-- AWARD 奖项评选 -->
        <div id="award-area">
            <p id="s-award"></p>
            <div class="section award">
                <div class="s-title">
                    <div class="zh-wrap">
                        <span class="zh">奖项评选</span>
                    </div>
                </div>
                <div class="award-list-wrap">
                    <a class="award-item" target="_blank" href="https://jinshuju.net/f/gy0mOM">2020年度准独角兽企业TOP 30</a>
                    <a class="award-item" target="_blank" href="https://jinshuju.net/f/o0V6w5">2020年度 30 under 30 新锐投资人 </a>
                    <a class="award-item" target="_blank" href="https://jinshuju.net/f/ZaCdGH">2020年度新消费领域新锐投资人TOP 10 </a>
                    <a class="award-item" target="_blank" href="https://jinshuju.net/f/g3u3PY">2020年度企业服务领域新锐投资人TOP 10 </a>
                    <a class="award-item" target="_blank" href="https://jinshuju.net/f/P5EOnU">2020年度工业互联网领域新锐投资人TOP 10</a>
                </div>
                <div class="award-content">
                </div>
            </div>
        </div>

        <!-- 参会人群分析-->
        <div id="participator-area">
            <div class="section tickets">
                <div class="s-title">
                    <div class="zh-wrap">
                        <span class="zh">参会人群分析</span>
                    </div>
                </div>
                <div class="participator-content">
                    <div class="partici-img" ></div>
                </div>
            </div>
        </div>

        <!-- tickets  -->
        <div id="tickets-bg-area">
            <div class="section tickets">
                <p id="s-tickets"></p>
                <div class="s-title">
                    <div class="zh-wrap">
                        <span class="zh">参会购票</span>
                    </div>
                </div>
                <a class="tickets-content" href="https://www.huodongxing.com/event/1567573387600" target="_blank"></a>
            </div>
        </div>

        <div class="section tickets">
            <p id="s-tickets"></p>
            <div class="s-title">
                <div class="zh-wrap">
                    <span class="zh">往届回顾</span>
                </div>
            </div>
            <div class="old-version">
                <a target="_blank" href="https://www.xfz.cn/explore/xfz2019/"></a>
                <a target="_blank" href="https://www.xfz.cn/explore/bufan2018/"></a>
                <a target="_blank" href="https://www.xfz.cn/explore/xfz2017/"></a>
                <a target="_blank" href="https://www.xfz.cn/explore/xfz2016/"></a>
            </div>
        </div>

        <!-- faq -->
        <div id="faq-bg-area">
            <div class="section faq">
                <p id="s-faq" ></p>
                <div class="s-title">
                    <div class="zh-wrap">
                        <span class="zh">FAQ-参会指南</span>
                        <!-- <span class="tip">按名字首字母排序</span> -->
                    </div>
                </div>
                <div class="container">
                    <div class="faq-item">
                        <div class="line-q">
                            <span>Q:</span>
                            <div class="content">
                                购票什么时候截止?
                            </div>
                        </div>
                        <div class="line-a">
                            <span>A:</span>
                            <div class="content">
                                购票截止日期为 2020年11月25日，中午12:00
                            </div>
                        </div>

                        <div class="line-q">
                            <span>Q:</span>
                            <div class="content">
                                购票付款成功后，如何获得参会凭证？
                            </div>
                        </div>
                        <div class="line-a">
                            <span>A:</span>
                            <div class="content">
                                在您成功付款后，您将收到短信提醒，内容包含参会信息及电子票二维码，活动时凭电子票二维码入场。<br>活动开始前一周，还会短信发送一次参会信息。如果您关注了小饭桌微信公众号，届时也会有相应提醒。
                            </div>
                        </div>

                        <div class="line-q">
                            <span>Q:</span>
                            <div class="content">
                                观众座位是否有预留？会议现场是否需要对号入座，会议中途离开，座位是否保留？
                            </div>
                        </div>

                        <div class="line-a">
                            <span>A:</span>
                            <div class="content">
                                请您核对票务权益，限量体验票、早鸟票用户根据进场顺序安排，不确保坐席，如您中途离开会场，不确保保留座位。
                            </div>
                        </div>

                        <div class="line-q">
                            <span>Q:</span>
                            <div class="content">
                                大会场馆附近有就餐的地方吗？
                            </div>
                        </div>

                        <div class="line-a">
                            <span>A:</span>
                            <div class="content">
                                酒店1层设有自助餐厅；距会场2-5分钟，步行即可到达诸多卖场，中餐、西餐、港式餐厅等，价位不等，有多样选择。
                            </div>
                        </div>

                        <div class="line-a">
                            <div class="sa-title">温馨提示：</div>
                            <div class="sa-content">
                                1) 大会门票仅为“999元”票档开具增值税普通发票，不提供增值税专用发票；<br>
                                2) 开票内容为：会议服务费； <br>
                                3) 因本公司每月增值税普通发票数量有限，将以申请开票的先后顺序开具并安排快递，不保证当月开票，请谅解。<br>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>

        <!-- partners  -->
        <div id="partners-bg-area">
            <div class="section partners">
                <p id="s-partners"></p>
                <div class="s-title">
                    <div class="zh-wrap">
                        <span class="zh">合作机构</span>
                        <!-- <span class="tip">按名字首字母排序</span> -->
                    </div>
                </div>
                <div class="container">
                    <dl>
                        <template v-for="partner in partnerList">
                            <template v-for="(val, key) in partner">
                                <dt>{{ key }}</dt>
                                <dd>
                                    <img v-for="pic in val" :src="pic.logo + '-fintech.partner'">
                                </dd>
                            </template>
                        </template>
                    </dl>
                </div>
            </div>
        </div>

        <!-- location -->
        <div class="section location">
            <p id="s-location"></p>

            <div class="s-title">
                <div class="zh-wrap">
                    <span class="zh">会议地址</span>
                    <!-- <span class="tip">按名字首字母排序</span> -->
                </div>
            </div>
            <div class="container">
                <div class="location-wrap">
                    <div class="address-info">
                        <div>
                            地铁10号线：金台夕照站 A口出，西行420米即到
                        </div>
                        <div>
                            自驾：北京市朝阳区东三环中路七号，千禧大酒店
                        </div>
                    </div>
                    <a href="https://j.map.baidu.com/22/en" target="_blank">
                        <img src="../assets/f-pc/map.png" alt="">
                    </a>
                </div>
            </div>
        </div>

        <!-- about us -->
        <div class="section about-us">
            <p id="s-contact-us"></p>

            <div class="s-title">
                <div class="zh-wrap">
                    <span class="zh">联系我们</span>
                    <!-- <span class="tip">按名字首字母排序</span> -->
                </div>
            </div>
            <div class="about-us-wrap">
                <div class="user-item">
                    <div class="title">市场合作</div>
                    <div class="name">罗阳-Rick</div>
                    <div class="phone">188-1179-5758</div>
                    <div class="email">luoyang@xfz.cn</div>
                </div>

                <div class="user-item">
                    <div class="title">媒体合作</div>
                    <div class="name">罗阳-Rick</div>
                    <div class="phone">188-1179-5758</div>
                    <div class="email">luoyang@xfz.cn</div>
                </div>

                <div class="user-item">
                    <div class="title">报名咨询</div>
                    <div class="name">白怡-Nina</div>
                    <div class="phone">159-0133-7648</div>
                    <div class="email">baiyi@xfz.cn</div>
                </div>
                <div class="qrcode" v-if="false">
                    <img src="https://www.xfz.cn/static/build/images/xfz-school-wechat-share.png">
                    <div class="qrcode-info">
                        <span>扫描二维码<br> 关注小饭桌</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 直播入口 -->
        <div class="bottom-buy-link-float" v-if="false">
            <a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  :href="newsUrl" target="_blank">
                <img src="../assets/f-pc/live-logo.png">
            </a>
        </div>
    </div>
</template>

<script>

import AgendaItem from './AgendaItem'
import TicketItem from './TicketItem'
import util from '../assets/js/util'
import oldGuests from '../assets/js/guest_data'

export default{
    components: {
        AgendaItem,TicketItem
    },
    data(){
        return{
            showNav: true,
            showAgendaMenu: false, // 固定的 menu
            showAgendaMenu2: true,// 不固定的 menu
            guestList: [],  // 嘉宾
            partnerList: [], // 合作伙伴
            agendaData: {
                meeting: {},
                type:[]
            }, // 日程列表
            whichConf:'', // 哪个会议
            whichHost:'', // 哪个主持人
            currentAgendaData: [],
            activeAgendaMenu: '',
            activeAgendaMenuIndex: 0,
            showMoreFaq: false,
            oldGuests: oldGuests,
            ticketUrl: "https://www.xfz.cn/form/conference?acid=XaDLBoWpsm",
            newsUrl: "https://www.xfz.cn/explore/xfz2019/news/",
            // newsUrl: "https://www.bufanbiz.com/explore/bufan2018/news/",
            // ticketUrl: "",
        }
    },
    methods:{
        getGuestData() {
            var self = this
            util.resource({
                url: '/explore/xfz2020_api/guest/',
                method: 'get',
                success (res) {
                    if (res.code == 200) {
                        self.guestList = res.data
                    }
                }
            })
        },
        getPartnerData() {
            var self = this
            util.resource({
                url: '/explore/xfz2020_api/company/',
                method: 'get',
                success (res) {
                    if (res.code == 200) {
                        self.partnerList = res.data
                    }
                }
            })
        },
        getAgendaData() {
            var self = this
            util.resource({
                url: '/explore/xfz2020_api/meeting/',
                method: 'get',
                success (res) {
                    if (res.code == 200) {
                        self.agendaData = res.data
                        self.activeAgendaMenu = self.agendaData.type[0][0] // 默认显示第一个议程
                        self.changeCurrentAgenda(self.activeAgendaMenu,0)
                    }
                }
            })

        },
        changeCurrentAgenda(agenda,index){
            this.whichConf = agenda.split('|')[0]
            this.whichHost = agenda.split('|')[1]
            this.activeAgendaMenu = agenda
            this.activeAgendaMenuIndex = index
            this.currentAgendaData = this.agendaData.meeting[agenda]
        },
        gotoAgenda(date){
            location.href = "#s-agenda"
            if(date == 'date1'){
                this.changeCurrentAgenda(this.agendaData.type[0][0],0)
            } else if (date == 'data2'){
                this.changeCurrentAgenda(this.agendaData.type[1][0],4)
            }
        },
        gotoVipAgenda(title){
            this.whichConf = title.split('|')[0]
            this.whichHost= title.split('|')[1]
            this.changeCurrentAgenda(this.agendaData.type[0][4])
        },
        listenScroll() {
            var self = this
            var offset = $('#participator-area').offset().top + 200
            var flag = true;
            $(window).scroll(function () {
                var scrollTop = $(window).scrollTop();
                if (scrollTop > offset ){
                    if (flag) {
                        // self.runCountUp();
                        flag = false;
                    }
                }
            });
        },
        runCountUp() {
            var options = {
              useEasing: true,
              useGrouping: true,
              separator: ',',
              decimal: '.',
              suffix: '+'
            };
            var countup1 = new CountUp('countup-target1', 0, 3000, 0, 3.5, options);
            var countup2 = new CountUp('countup-target2', 0, 80, 0, 3.5, options);
            var countup3 = new CountUp('countup-target3', 0, 50, 0, 3.5, options);
            var countup4 = new CountUp('countup-target4', 0, 60, 0, 3.5, options);
            var countup5 = new CountUp('countup-target5', 0, 60, 0, 3.5, options);
            var countup6 = new CountUp('countup-target6', 0, 150, 0, 3.5, options);
            if (!countup1.error) {
              countup1.start();
              countup2.start();
              countup3.start();
              countup4.start();
              countup5.start();
              countup6.start();
            } else {
              console.error(demo.error);
            }
        },
    },
    mounted(){
        document.title = '2020小饭桌青年创业者大会！'
        this.getGuestData()
        this.getPartnerData()
        this.getAgendaData()
        this.listenScroll()
        // util.getWx()
    }
}
</script>

<style lang="scss" scoped>
#home-pc{
    font-size: 14px;
    min-width: 1200px;
    width: 100%;
    background: url('../assets/20-pc/main_bg.png');
    background-repeat: repeat-y;
    background-size: contain;
    .header-wrap{
        // border: 1px solid red;
        width: 100%;
        min-height: 1100px;
        margin-top: -120px;
        background: url('../assets/20-pc/banner_bg.png');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: 50%;
        // background-size: cover;
        .menu-logo {
            float: left;
            width: 160px;
            margin-left: 90px;
            margin-top: 8px;
        }
        .nav{
            position: fixed;
            top:0;
            left: 0;
            z-index: 999;
            right: 0;
            text-align: right;
            padding-right: 200px;
            background-color: rgba(0,0,0,.3);
            ul {
                margin: 0 auto;
                width: 1200px;
                display: block;
                li {
                    height: 50px;
                    line-height: 50px;
                    cursor: pointer;
                    font-weight: bold;
                    font-size: 20px;
                    display: inline-block;
                    list-style: none;
                    padding-right: 20px;
                    img{
                        height: 35px;
                        float: left;
                        padding-top: 10px;
                    }
                    span{
                        color: #fff;
                        font-size: 18px;
                    }
                    a {
                        text-decoration: none;
                        color: #fff;
                    }
                    &:hover {
                        .nav-link{
                            border-bottom: 4px solid #ff9671;
                            padding-bottom: 11px;
                            color: #fff;
                        }
                    }
                }
                .active{
                }
            }
        }

        .guest-title-image {
            position: absolute;
            width: 840px;
            top: 1170px;
            left: 50%;
            margin-left: -280px;
            z-index: 99;
            font-size: 18px;
        }
    }
    .intro-content {
        width: 100%;
        font-size: 28px;
        color: #fff;
        line-height: 2.0;
        margin: 0 auto;
        margin-top: -180px;
        .intro-normal {
            width: 990px;
            margin: 0 auto;
        }
        .intro-bold {
            width: 1000px;
            margin: 0 auto;
            line-height: 2.5;
            font-weight: bold;
        }
    }
    .past-guest {
        ul {
            width: 1200px;
            margin: 0 auto;
            text-align: center;
            li {
                display: inline-block;
                width: 200px;
                height: 500px;
                cursor: pointer;
                margin-right: 10px;
                position: relative;
                .play-btn {
                    display: none;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    margin-left: -50px;
                    margin-top: -50px;
                }
            }
            li:hover {
                .play-btn {
                    display: block;
                }
            }
        }
    }
    #guest-bg-area{
        background-position: top;
        background-repeat: no-repeat;
        margin-top: -1px;
    }
    .guest{
        margin-top: 10px;
        overflow: auto;
        margin-bottom: 50px;
        overflow: hidden;
        ul.guest-list {
            // border: 1px solid red;
            margin: 0 auto 30px;
            width: 990px;
            overflow: visible;
            padding-top: 40px;
            display: flex;
            justify-content: start;
            flex-wrap: wrap;
            li {
                // border: 1px solid green;
                width: 174px;
                margin-left: 20px;
                overflow: hidden;
                -webkit-transition: all 0.3s;
                transition: all 0.3s;
                text-align: center;
                color: #273748;
                list-style: none;
                margin-bottom: 20px;
                .photo {
                    // border: 1px solid red;
                    overflow: hidden;
                    position: relative;
                    width: 174px;
                    height: 270px;
                    img {
                        // border: 1px solid #fff;
                        display: block;
                        padding: 10px;
                        width: 174px;
                        height: 174px;
                        top: 0px;
                        left: 0px;
                        z-index: 99;
                        position: absolute;
                    }
                    .right-bottom {
                        position: absolute;
                        top: 185px;
                        left: 0;
                        right: 0;
                        color: #fff;
                        .g-name {
                            font-size: 20px;
                            font-weight: bold;
                        }
                        .g-title {
                            margin-top: 4px;
                            font-size: 16px;
                        }
                    }
                }

            }
        }
    }

    #agenda-bg-area {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
    }

    .agenda{
        width: 990px;
        margin: 0 auto;
        margin-top: 0px;
        color: #fff;
        background-blend-mode: normal, normal;
        .agenda-title-bottom {
            width: 1000px;
            height: 10px;
            // background-image: linear-gradient(-90deg,rgba(255, 222, 212, 0) 40%, #ffd194 100%), linear-gradient( rgba(255, 222, 212, 0), rgba(255, 222, 212, 0));
            background-blend-mode: normal, normal;
        }
        .agenda-group-0, .agenda-group-1, .agenda-group-2, .agenda-group-3{
            vertical-align: top;
            margin-top: 0px;
            background-size: 100%;
            width: 1100px;
            margin-bottom: 40px;
        }
        .title{
            height: 200px;
        }
        .conf-host{
            margin-bottom: 20px;
            font-size: 22px;
            font-weight: bold;
            .which-conf{
                display: inline-block;
                font-size: 32px;
                margin-bottom: 5px;
                margin-left: 30px;
                span{
                    font-weight: bold;
                    display: inline-block;
                    height: 40px;
                }
                .see-map {
                    color: #fff;
                    font-size: 24px;
                    margin-left: 20px;
                    font-weight: lighter;
                }
            }
            .which-host{
                display: inline-block;
                font-size: 20px;
                margin-left: 10px;
                vertical-align: bottom;
            }
        }
        .agenda-list{
            font-size: 0px;
        }
        .time-address {
            width: 990px;
            color: #fff;
            font-size: 24px;
            padding: 2px;
            text-align: center;
            background: #147aff;
        }
    }
    .agenda-2 {
        width: 900px;
        margin: 0 auto;
        img {
            width: 900px;
        }
    }
    #tickets-bg-area{
        height: 500px;
    }
    #participator-area {
        text-align: center;
        .participator-content {
            width: 1200px;
            margin: 0 auto;
            .partici-img {
                background: url('../assets/20-pc/6_group.png');
                width: 990px;
                margin: 0 auto;
                height: 420px;
                background-size: cover;
                // border: 1px solid red;
            }
            .item {
                width: 300px;
                height: 300px;
                color: #fff;
                font-size: 28px;
                display: inline-block;
                padding-top: 100px;
                background: url('../assets/f-pc/dot.png');
                background-repeat: no-repeat;
                background-position: center;
                .title {
                    font-weight: bold;
                }
                .count {
                    font-size: 42px;
                    padding-top: 5px;
                }
            }
        }
    }
    #award-area {
        height: 500px;
        padding: 50px 0;
    }
    .award {
        background-size: cover;
        position: relative;
        height: 400px;
        background-position-x: 50%;
        background-position-y: 50%;
        background-repeat: no-repeat;
        .award-list-wrap {
            width: 990px;
            margin: 0 auto;
            font-size: 28px;
            color: #fff;
            .award-item {
                color: #fff;
                padding: 12px;
                display: block;
                text-decoration: none;
                &:before{
                    content: '  ';
                    width: 30px;
                    height: 30px;
                    display: inline-block;
                    margin-top: 6px;
                    vertical-align: top;
                    margin-right: 15px;
                    background: url('../assets/20-pc/dot.png');
                    background-size: cover;
                }
            }
        }
        .award-content {
            width: 1100px;
            margin: 0 auto;
            height: 400px;
            img {
                margin-right: 40px;
                margin-bottom: 40px;
                width: 500px;
                cursor: pointer;
                &:hover {
                    border: 1px solid red;
                }
            }
        }

    }
    .tickets{
        width: 100%;
        .tickets-content{
            width: 1200px;
            height: 400px;
            padding: 30px 0;
            margin: 0 auto;
            display: block;
            text-align: center;
            background: url('../assets/20-pc/ticket_group.png');
            background-size: contain;
            background-repeat: no-repeat;
            a{
                vertical-align: top;
                display: inline-block;
                text-decoration: none;
                margin-right: 40px;
            }
            .ticket-item{
                width: 230px;
                height: 345px;
                padding: 20px;
                background-repeat: no-repeat;
                text-decoration: none;
                color: #fff;
                position: relative;
                text-align: left;
                .name{
                    font-size: 27px;
                    font-weight: bold;
                }
                .price{
                    background-color: #ec1c24;
                    display: inline-block;
                    padding:0 8px;
                    margin: 5px 0;
                    font-size: 27px;
                    font-weight: bold;
                }
                .content{
                    font-size: 13px;
                    width: 200px;
                    line-height: 1.6;
                    text-align: left;
                }
                .seat{
                    position: absolute;
                    bottom: 18px;
                    left: 0;
                    right: 0;
                    font-size: 15px;
                    text-align: center;
                }
                .buy-btn{
                    display: none;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 100px;
                    // background: url('../assets/n-pc/buy-btn-bg.png');
                }
                &:hover{
                    .buy-btn{
                        display: block;
                    }
                }
            }
        }
    }
    .old-guests{
        height: 800px;
        .container{
            max-width: 1200px;
            text-align: center;
            margin: 0 auto;
            .old-guest-item{
                display: inline-block;
                width: 173px;
                color: #ec1c24;
                text-align: center;
                margin-bottom: 15px;
                margin-right: 30px;
                img{
                    width: 173px;
                }
                .guest-name{
                    font-size: 18px;
                }
                .guest-title{
                    font-size: 13px;
                }
            }
        }
        .container :nth-child(6n){
            margin-right: 0px;
        }
    }
    #faq-bg-area {
        padding-bottom: 10px;
    }
    .old-version {
        background: url('../assets/20-pc/data_group.png');
        background-size: contain;
        background-position: 50%;
        width: 980px;
        margin: 0 auto;
        height: 220px;
        background-repeat: no-repeat;
        // border: 1px solid red;
        text-align: center;
        a {
            display: inline-block;
            width: 22%;
            height: 100%;
            // border: 1px solid red;
        }
    }
    .faq{
        .container{
            margin: 0 auto;
            width: 990px;
            color: #fff;
            font-size: 24px;
            line-height: 1.6;
            .line-a{
                margin-bottom: 10px;
            }
            .line-q, .line-a{
                span{
                    font-size: 30px;
                    color: #ffc485;
                    padding-right: 4px;
                    vertical-align: top;
                    display: inline-block;
                    margin-top: -6px;
                }
                .content{
                    display: inline-block;
                    max-width: 900px;
                    vertical-align: top;
                }
            }
            .faq-more-btn{
                cursor: pointer;
                color: #ffc485;
                text-align: center;
                margin-left: 0px;
                margin-bottom: 40px;
            }
            .sa-title{
                margin: 20px 0 10px;
                font-size: 30px;
                color: #ffc485;
            }
            .sa-content{
                max-width: 950px;
                margin-bottom: 20px;
            }

        }
    }
    #partners-bg-area {
    }
    .partners {
        overflow: auto;
        padding-bottom: 60px;
        .container{
            margin-top: 50px;
            width: 990px;
            margin: 0 auto;
            background-color: grey;
        }
        dl {
            dt {
                clear: left;
                width: 180px;
                margin: 0 auto;
                padding-top: 15px;
                font-size: 24px;
                color: #ffc485;
                text-align: left;
                vertical-align: top;
                float: left;
                font-weight: bold;
                letter-spacing: 2px;
            }
            dd {
                min-height: 57px;
                display: block;
                float: left;
                width: 810px;
                margin-bottom: 20px;
                img {
                    // border: 1px solid #ccc;
                    height: 66px;
                    margin-right: 18px;
                    margin-bottom: 30px;
                }
            }
        }
    }
    .location{
        height: 990px;
        .top-icon{
            text-align: center;
            width: 400px;
            margin: 0 auto;
            margin-bottom: -10px;
        }
        .container{
            .location-wrap{
                color: #fff;
                max-width: 990px;
                text-align: center;
                margin: 0 auto;
                .address-info{
                    width: 1100px;
                    vertical-align: top;
                    text-align:left;
                    color: #fff;
                    font-size:20px;
                    padding: 20px 0;
                    font-weight: bold;
                    margin: 30px auto 0;
                    line-height: 2;
                }
                img {
                    margin-top: 20px;
                    display: inline-block;
                    width: 990px;
                }
            }
        }
    }
    .about-us{
        // background-color: #081446;
        height: 480px;
        width: 100%;
        .about-us-wrap{
            width: 990px;
            margin: 0 auto;
            .user-item{
                vertical-align: bottom;
                display: inline-block;
                width: 260px;
                line-height: 1.4;
                margin-right: 50px;
                .title{
                    color: #ffc485;
                    font-size: 30px;
                    line-height: 30px;
                    padding-left: 4px;
                    margin-bottom: 20px;
                    font-weight: bold;
                }
                .name, .phone, .email{
                    color: #fff;
                    padding-left: 4px;
                    font-size: 24px;
                }
            }
            .qrcode{
                visibility: hidden;
                color: #fff;
                display: inline-block;
                text-align: center;
                vertical-align: bottom;
                img{
                    display: inline-block;
                    width: 120px;
                    height: 120px;
                }
            }
        }
    }
    .section{
        p{
            margin-bottom: 10px;
            height: 10px;
        }
        .s-title{
            max-width: 990px;
            margin: 30px auto 10px;
            color: #fff;
            font-size: 46px;
            text-align: left;
            // border: 1px solid red;
            .zh-wrap {
                .zh {
                    display: inline-block;
                    margin: 10px 0 20px;
                    padding-left: 4px;
                    font-weight: bold;
                    &:after {
                        content: " ";
                        display: inline-block;
                        width: 10px;
                        height: 45px;
                        margin-left: 20px;
                        margin-right: 10px;
                        vertical-align: text-top;
                        margin-top: 2px;
                        background: url('../assets/20-pc/session_title_bg.png');
                        background-size: cover;
                    }
                }
                .tip {
                    font-size: 24px;
                    font-weight: bold;
                }

            }
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-active {
        opacity: 0
    }
    .active-agenda-menu{
        opacity: 1!important;
    }
    .bottom-buy-link-float{
        position: fixed;
        cursor: pointer;
        bottom: 40px;
        right: 40px;
        z-index: 999;
    }
    .active{
        display: block;
    }

}
</style>



// WEBPACK FOOTER //
// HomePc.vue?6b20d5dc